import styled, { keyframes } from 'styled-components';
import bg from './img/bg.png';
import bgDark from './img/bgDark.png';

interface Props {
	value?: number;
}

interface PropsImageWrapper {
	darkTheme?: string;
}

export const Container = styled.div`
	position: relative;
	border-radius: 5px;
	padding: 6px;
	background: ${({ theme }) => theme.colors.primaryGradient9};
`;

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 7px;
	width: 100%;
`;

export const ImgWrapper = styled.div<PropsImageWrapper>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 7px;
	width: 100%;
	padding: 0 13px;
	margin-bottom: -9px;
	gap: 40px;
	background: ${({ darkTheme }) => (darkTheme === 'darkMode' ? `url(${bgDark})` : `url(${bg})`)};
	background-repeat: no-repeat;
	background-size: contain;
	background-position: center;

	img {
		flex: 1;
		width: 100%;
	}
`;

export const Label = styled.p`
	color: ${({ theme }) => theme.colors.text5};
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg1};
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 13px;

	&:last-child {
		color: ${({ theme }) => theme.colors.text26};
		font-weight: 800;
	}
`;

export const InfoWrapper = styled.div`
	padding: 16px;
	border-radius: 5px;
	background: ${({ theme }) => theme.colors.bg1};
	box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
	flex: 1;
	width: 100%;
	color: ${({ theme }) => theme.colors.text5};
	font-size: 12px;
	font-weight: 400;
	line-height: 14px;
	gap: 12px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
`;

export const InfoTitle = styled.p`
	font-weight: 700;
	margin-top: 2px;
`;

export const InfoHeader = styled.div``;

export const Line = styled.div`
	width: 100%;
	height: 1px;
	background: #dbdbdb; ;
`;

export const InfoFooter = styled.div`
	width: 100%;
`;

export const Scale = styled.div<Props>`
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	gap: 4px;
	margin-top: 12px;

	div {
		flex: 1;
		border-radius: 2px;
		height: 9px;
		background: rgba(119, 30, 174, 0.2);
	}

	div:nth-child(1) {
		background: ${({ value, theme }) =>
			value && value >= 1 ? theme.colors.text26 : 'rgba(119, 30, 174, 0.20)'};
	}

	div:nth-child(2) {
		background: ${({ value, theme }) =>
			value && value >= 2 ? theme.colors.text26 : 'rgba(119, 30, 174, 0.20)'};
	}

	div:nth-child(3) {
		background: ${({ value, theme }) =>
			value && value >= 3 ? theme.colors.text26 : 'rgba(119, 30, 174, 0.20)'};
	}
`;
